import RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import Route from "@mpa/toolbox/navigation/Route";

export const rootNavigator = new RouteNavigator();
export const indexRoute = rootNavigator.addRoute(new Route().setPath("/"));
